import { useQuery } from "@tanstack/react-query";
import { getProjectOffers } from "@/app/actions/offer/get/action";
import { QueryKey } from "@/app/vars/QueryKeys";

export function useFetchProjectOffers(options: { projectId?: number; enabled?: boolean } = {}) {
  const { projectId, enabled = true } = options;

  return useQuery({
    queryKey: [QueryKey.PROJECT_OFFER, projectId],
    queryFn: () => getProjectOffers(projectId!),
    enabled: enabled && !!projectId,
    staleTime: Infinity,
  });
}
